import { format, isBefore, isSameDay, startOfDay } from 'date-fns';

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export function isProjectDateOnlyString(value: unknown): value is string {
  return typeof value === 'string' && DATE_ONLY_REGEX.test(value.trim());
}

export function projectDateToInputValue(value: unknown): string {
  if (!value) return '';

  if (isProjectDateOnlyString(value)) {
    return value.trim();
  }

  const parsed = new Date(value as string | number | Date);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  return format(parsed, 'yyyy-MM-dd');
}

export function projectDateToLocalDate(value: unknown): Date | undefined {
  if (!value) return undefined;

  if (isProjectDateOnlyString(value)) {
    const [year, month, day] = value.trim().split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value as string | number | Date);
  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }

  return parsed;
}

export function isProjectDateSameDay(
  value: unknown,
  date: Date,
): boolean {
  const projectDate = projectDateToLocalDate(value);
  return !!projectDate && isSameDay(projectDate, date);
}

export function isProjectDateBeforeDay(
  value: unknown,
  date: Date,
): boolean {
  const projectDate = projectDateToLocalDate(value);
  return !!projectDate && isBefore(startOfDay(projectDate), startOfDay(date));
}
